import React, { useState } from 'react'
import styles from './resumen-coberturas.module.css'
import * as Globales from '../../../../utils/globales'
import * as Funciones from '../../../../utils/funciones'

const ResumenCoberturas = ({ productos, state, setState, leyenda }) => {
    let textosAlias = [
        {
            idAliasCoberturaCliente: '01',
            descripcion: 'Muerte natural',
            sumas: []
        },
        {
            idAliasCoberturaCliente: '02',
            descripcion: 'Muerte accidental',
            sumas: []
        },
        {
            idAliasCoberturaCliente: '03',
            descripcion: 'Invalidez',
            sumas: []
        },
        {
            idAliasCoberturaCliente: '04',
            descripcion: 'Otras coberturas',
            sumas: []
        }
    ]

    const [stateLocal] = useState({ textosAlias })

    const expandirProducto = (id) => {
        setState({
            ...state,
            expandeProd: state.expandeProd.map(producto => {
                if (producto.id === id) {
                    producto.valor = !producto.valor
                }
                return producto
            })
        })
    }

    const valorExpande = (id) => {
        let expandir = state.expandeProd.find(producto => producto.id === id)

        return expandir.valor
    }

    const obtenerDescripcionCoberturas = (cobertura, id) => {
        let newLeyenda = leyenda.filter((v, i, a) => a.findIndex(v2 => (v2.nombreTxtLegal === v.nombreTxtLegal)) === i)

        if (newLeyenda.length === 2) {
            if (Globales.CODIGOS_COBERTURAS_INVALIDEZ.includes(cobertura.codigoCobertura) ||
                Globales.CODIGOS_COBERTURAS_EDM.includes(cobertura.codigoCobertura)) {
                return (<ul key={id}>{cobertura.descripcion} <sup>(2)</sup></ul>)
            } else {
                return (<ul key={id}>{cobertura.descripcion}</ul>)
            }
        } else {
            if (Globales.CODIGOS_COBERTURAS_INVALIDEZ.includes(cobertura.codigoCobertura)) {
                return (<ul key={id}>{cobertura.descripcion} <sup>(2)</sup></ul>)
            } else if (Globales.CODIGOS_COBERTURAS_EDM.includes(cobertura.codigoCobertura)) {
                return (<ul key={id}>{cobertura.descripcion} <sup>(3)</sup></ul>)
            } else {
                return (<ul key={id}>{cobertura.descripcion}</ul>)
            }
        }
    }

    const mostrarFormatoMonto = (monto) => {
        if (monto === '—' || monto === 'Aplica') {
            return monto
        } else {
            return Funciones.mostrarFormatoMoneda(monto)
        }
    }

    const renderMontos = (producto, codigo) => {
        let listaAlias = producto.listaAlias !== undefined ? producto.listaAlias.filter(li => li.idAliasCoberturaCliente === codigo) : []

        let listaMontos = null
        listaMontos = producto.coberturas.map(cobertura => {
            return {
                codigoCobertura: cobertura.codigoCobertura,
                descripcion: cobertura.descripcion,
                monto: '—'
            }
        })

        if (listaAlias.length > 0) {
            listaMontos.map(monto => {
                listaAlias.map(alias => {
                    if (parseInt(alias.codigoCobertura) === monto.codigoCobertura) {
                        if (Globales.CODIGOS_COBERTURAS_EDM.includes(parseInt(alias.codigoCobertura))) {
                            monto.monto = 'Aplica'
                        } else {
                            monto.monto = alias.monto
                        }
                    }
                    return alias
                })
                return monto
            })
        }

        return (
            listaMontos.map(monto => (
                <ul className={styles.monto_ul}
                    key={monto.codigoCobertura}
                    style={monto.descripcion.length > 32 ? { height: '28.5px' } : {}}
                >
                    {mostrarFormatoMonto(monto.monto)}
                </ul>
            ))
        )
    }

    const renderSumaPorProducto = (producto, codAlias) => {
        let listaAlias = producto.listaAlias !== undefined ? producto.listaAlias.filter(li => li.idAliasCoberturaCliente === codAlias) : []
        let sumaProducto = null

        if (listaAlias.length > 0) {
            let nuevo = listaAlias.filter(alias => !Globales.CODIGOS_COBERTURAS_EDM.includes(parseInt(alias.codigoCobertura)))
            if (nuevo.length > 0) {
                sumaProducto = listaAlias.reduce((sum, { monto }) => sum + monto, 0)
            } else {
                sumaProducto = '—'
            }
        } else {
            sumaProducto = '—'
        }

        let aliases = stateLocal.textosAlias
        aliases.map(text => {
            if (text.idAliasCoberturaCliente === codAlias) {
                text.sumas = [...new Set([...text.sumas, sumaProducto])]
            }
            return text
        })

        return sumaProducto !== '—' ? Funciones.mostrarFormatoMoneda(sumaProducto) : sumaProducto
    }

    const sumasTotales = (alias) => {
        let sumaTotal = null
        if (alias.sumas !== undefined && alias.sumas.length > 0) {
            let validaSuma = alias.sumas.every(sum => sum === '—')
            if (validaSuma) {
                sumaTotal = '—'
            } else {
                let newSuma = alias.sumas.filter(sum => sum !== '—')
                sumaTotal = newSuma.reduce((a, b) => a + b, 0)
            }
        } else {
            sumaTotal = ''
        }

        return sumaTotal !== '—' ? Funciones.mostrarFormatoMoneda(sumaTotal) : sumaTotal
    }

    return (
        <React.Fragment>
            <div className={styles.grid_textos}>
                <div className={styles.gt_text1}>
                    <span>Por los siguientes productos y coberturas</span>
                </div>
                <div className={styles.gt_text2}>
                    <span>Sus beneficiarios recibirían uno de estos montos en caso fallecieras.</span>
                </div>
                <div className={styles.gt_text3}>
                    <span>Recibirás en vida, de producirse un siniestro.</span>
                </div>
            </div>
            <div className={styles.grid_planes}>
                <div className={styles.gp_space}></div>
                {stateLocal.textosAlias.map((alias, index) => (
                    <div key={index} className={styles['gp_plan'.concat(alias.idAliasCoberturaCliente)]}>
                        <span>{alias.descripcion}</span>
                    </div>
                ))}
            </div>
            {productos !== undefined && productos.length > 0 &&
                productos.map((producto) => (
                    <div key={producto.codigoProducto}>
                        <div className={styles.grid_productos}>
                            <div className={styles.gp_producto} style={producto.descripcion.length > 25 ?
                                null : { paddingTop: '14px' }}>
                                <span className={styles.span_producto}
                                    style={producto.descripcion.length > 25 ?
                                        { paddingBottom: '8px', fontSize: '13px' } : null}
                                >
                                    {producto.descripcion}
                                </span>
                                <div
                                    onClick={() => expandirProducto(producto.codigoProducto)}
                                    className={`${styles.reducido} ${!valorExpande(producto.codigoProducto) ? null : styles.expandido}`}
                                />
                            </div>
                            {stateLocal.textosAlias.map((alias, index) => (
                                <div key={index} className={styles['gp_monto'.concat(alias.idAliasCoberturaCliente)]}>
                                    {renderSumaPorProducto(producto, alias.idAliasCoberturaCliente)}
                                </div>
                            ))}
                        </div>
                        {valorExpande(producto.codigoProducto) ?
                            <div className={styles.grid_coberturas}>
                                <div className={styles.gc_cobertura}>
                                    {producto.coberturas.map((cobertura, index) => (
                                        obtenerDescripcionCoberturas(cobertura, index)
                                    ))}
                                </div>
                                {stateLocal.textosAlias.map((alias, index) => (
                                    <div key={index} className={styles['gc_montos'.concat(alias.idAliasCoberturaCliente)]}>
                                        {renderMontos(producto, alias.idAliasCoberturaCliente)}
                                    </div>
                                ))}
                            </div>
                            : null
                        }
                    </div>
                ))
            }
            <div className={styles.grid_sumas}>
                <div className={styles.gs_total}>
                    Suma de coberturas <sup>(1)</sup>
                </div>
                {stateLocal.textosAlias.map((alias, index) => (
                    <div key={index} className={styles['gs_suma'.concat(alias.idAliasCoberturaCliente)]}>
                        {sumasTotales(alias)}
                    </div>
                ))}
            </div>
        </React.Fragment>
    )
}

export default ResumenCoberturas